module.exports = __webpack_public_path__ + "img/jp4@2x.817e9513.png";